import PointService from "@/services/PointService.js";

export default {
  namespaced: true,
  state: {
    balance: 0,
    loading: false,
    errors: null,
    submitReceiptResponse: null
  },
  getters: {
    pointsWithCommas: state => {
      return state.balance.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    getReceiptSubmissionResponse: state => {
      return state.submitReceiptResponse;
    }
  },
  mutations: {
    SET_LOADING(state, value) {
      state.loading = value;
    },
    SET_BALANCE(state, balance) {
      state.balance = balance;
    },
    SET_ERRORS(state, errors) {
      state.errors = errors;
    },
    RESET_ERRORS(state) {
      state.errors = null;
    },
    SET_SUBMIT_RECEIPT_RESPONSE(state, response) {
      state.submitReceiptResponse = response;
    }
  },
  actions: {
    async resetErrors({ commit }) {
      commit("RESET_ERRORS");
    },
    getCustomerBalance: async ({ commit }, request) => {
      commit("SET_ERRORS", null);
      commit("SET_LOADING", true);
      try {
        let response = await PointService.getCustomerBalance(request);
        commit("SET_BALANCE", response.balance);
        commit("SET_LOADING", false);
      } catch (errors) {
        commit("SET_ERRORS", errors);
      }
    },
    async submitReceipts({ commit }, request) {
      commit("SET_ERRORS", null);
      commit("SET_LOADING", true);
      try {
        let response = await PointService.submitReceipts(request);
        commit("SET_SUBMIT_RECEIPT_RESPONSE", response);
        commit("SET_LOADING", false);
      } catch (errors) {
        commit("SET_ERRORS", errors);
        commit("SET_LOADING", false);
      }
    },
    checkReceiptCapping: async ({ commit }, request) => {
      commit("SET_ERRORS", null);
      commit("SET_LOADING", true);
      try {
        let response = await PointService.checkReceiptCapping(request);
        commit("SET_LOADING", false);
        return response;
      } catch (errors) {
        commit("SET_ERRORS", errors);
      }
    },
  }
};
